export const getPreview = (content, maxLength = 150) => {
  const plainText = content
    .replace(/[#*_`\[\]]/g, '')
    .replace(/\n+/g, ' ')
    .trim();
  
  if (plainText.length > maxLength) {
    return plainText.substring(0, maxLength) + '...';
  }
  return plainText;
};
